import { ref, computed } from 'vue'

export function useFilterSort(itemsRef) {
  const filterText = ref('')
  const sortKey = ref('')
  const sortAsc = ref(true)

  const setSort = key => {
    if (sortKey.value === key) {
      sortAsc.value = !sortAsc.value
    } else {
      sortKey.value = key
      sortAsc.value = true
    }
  }

  const filteredSorted = computed(() => {    
    if (!itemsRef.value) return []
    
    const items = Array.isArray(itemsRef.value) ? itemsRef.value : []
    
    return items
      .filter(item => {
        if (!item) return false
        if (!filterText.value) return true
        
        return Object.values(item).some(val =>
          val != null && String(val).toLowerCase().includes(filterText.value.toLowerCase())
        )
      })
      .sort((a, b) => {
        if (!sortKey.value) return 0
        
        const valA = a?.[sortKey.value]
        const valB = b?.[sortKey.value]
        
        if (valA == null) return 1
        if (valB == null) return -1
        
        if (typeof valA === 'number' && typeof valB === 'number') {
          return sortAsc.value ? valA - valB : valB - valA
        }
        
        return sortAsc.value 
          ? String(valA).localeCompare(String(valB)) 
          : String(valB).localeCompare(String(valA))
      })
  })

  return { 
    filterText, 
    sortKey, 
    sortAsc, 
    setSort, 
    filteredSorted 
  }
}